import React, { useState, useEffect } from "react";
import { Container, Placeholder } from "react-bootstrap";
import { getAdBySize } from "../../services/adService";

interface AdData {
	url: string;
	imageUrl: string;
	width: number;
	height: number;
}

const FivebyNinetyAd: React.FC = () => {
	const [adData, setAdData] = useState<AdData | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchAd = async () => {
			try {
				setIsLoading(true);
				// Fetch ad with fivebynine size
				const response = await getAdBySize("fivebyninety");
				const data = response.data;
				setAdData({
					url: data.url,
					imageUrl: data.imageUrl,
					width: data.width,
					height: data.height,
				} as AdData);
				setError(null);
			} catch (err) {
				console.error("Failed to fetch ad:", err);
				setError("Failed to load advertisement");
			} finally {
				setIsLoading(false);
			}
		};

		fetchAd();
	}, []);

	if (isLoading) {
		return (
			<Placeholder as="div" animation="glow" className="">
				<Placeholder
					xs={11}
					className="rounded-3"
					bg="light"
					style={{ height: "23rem", width: "13rem" }}
				/>
			</Placeholder>
		);
	}

	if (error) {
		return null;
	}

	if (!adData) {
		return null;
	}

	return (
		<Container className="p-0 my-2 text-center">
			<a href={adData.url} target="_blank" rel="noopener noreferrer">
				<img
					src={adData.imageUrl}
					alt="Advertisement"
					style={{
						width: "30rem",
						height: 'auto',
					}}
					className="img-fluid"
				/>
			</a>
		</Container>
	);
};

export default FivebyNinetyAd;
